<template>
  <div class="payment-methods">
    <action-dispatcher action="product/getPaymentMethods">
      <div v-if="!isEdit">
        <div class="d-flex align-items-center">
          <h4>Formas de pagamento</h4>
          <span class="text-negative-600 ml-2">*</span>
        </div>
        <span class="text-neutral-400 functional-1">
          Informe como você deseja monetizar o seu
          {{ isEvent ? "evento presencial" : "curso online" }}.
        </span>
        <div
          v-if="!isEvent"
          class="p-3 my-5 border rounded border-information-400"
        >
          <div class="d-flex gap-3">
            <bp-icon icon="fa fa-info-circle" class="text-information-500" />
            <span class="functional-1 text-information-700">
              Caso você tenha configurado um valor em moeda estrangeira, o
              pagamento em Cartão de Crédito será assinalado automaticamente na
              listagem abaixo. Caso configure parcelamento, essa opção estará
              disponível no checkout apenas para compras em Real Brasileiro.
              Para compras internacionais, o checkout exibirá como forma de
              pagamento apenas o Cartão de Crédito à vista.
            </span>
          </div>
        </div>
      </div>

      <bp-checkbox-group
        v-model="innerValue"
        class="mt-5"
        :options="_paymentMethods"
        @input="updateValue"
      />
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Array
    },
    showForeignInfo: {
      type: Boolean,
      default: false
    },
    isEvent: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: [...this.value]
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods"]),
    _paymentMethods() {
      const warnings = {
        2: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque seguindo o prazo configurado para vencimento do boleto.",
        4: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque por um prazo de 24h."
      };

      let paymentMethods = [
        ...this.paymentMethods.map(m => ({
          id: m.id,
          name: m.name,
          disabled:
            !!this.innerValue.includes("parceled_billet") ||
            (!!this.showForeignInfo && m.id === 1),
          warning: this.isEvent ? warnings[m.id] : null
        }))
      ];
      if (!this.isEdit) {
        paymentMethods = [
          {
            id: "parceled_billet",
            name: "Boleto Parcelado",
            warning:
              "Ao selecionar Boleto Parcelado as outras opções de pagamento são desativadas."
          },
          ...paymentMethods
        ];
      }

      const order = [1, 4, 2, 3, 34, "parceled_billet"];

      const orderedPaymentMethods = paymentMethods.sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
      );

      return orderedPaymentMethods;
    }
  },
  methods: {
    updateValue(v) {
      if (v.includes("parceled_billet")) {
        this.innerValue = ["parceled_billet"];
      }
      this.$emit("input", this.innerValue);
    }
  },
  watch: {
    showForeignInfo(v) {
      if (!v) return;

      if (!this.innerValue.includes(1)) this.innerValue.push(1);
      this.$emit("input", this.innerValue);
    }
  }
};
</script>
